import TodoPanelStore from './schema/TodoPanelStore';
import createDropViewState from 'owa-dnd/lib/utils/createDropViewState';
import { createStore } from 'satcheljs';
import { ObservableMap } from 'mobx';

let getStore = createStore<TodoPanelStore>('todoPanelStore', <TodoPanelStore>{
    selectedFolderView: {
        folderId: null,
        activeTaskIds: [],
        recentlyCompletedTaskIds: [],
        todoItems: new ObservableMap(),
        folderViewState: {
            todoItemViewStates: new ObservableMap(),
            contextMenuViewState: null,
            currentEditingTodoId: '',
            focusTodoId: null,
            showCompletedTasks: false,
            dragToEndDropViewState: createDropViewState(),
            recentlyCompletedDropViewState: createDropViewState(),
        },
    },
    quickAddViewState: {
        isShown: true,
        subject: '',
        isFocused: false,
        linkedEmailEntity: null,
        extractionId: null,
    },
    dropViewState: createDropViewState(),
    folders: {
        folders: new ObservableMap(),
        orderedList: [],
        defaultFolderId: null,
    },
    showFlaggedEmailToggle: false,
    panelId: '',
    panelOpenTime: null,
    source: null,
    parentSessionId: '',
});

export default getStore;
